import React from 'react'
import Header from '../Layout/Header'
import HomeBanner from '../Home/HomeSections/Homebanner'
import AboutBlog from './AboutBlog'
import Lorem from '../Home/HomeSections/Lorem'
import Footer from '../Layout/Footer'

export default function About() {
  return (
    <div>
        <Header/>
        <HomeBanner
          title='About Toromail' 
          subtitle={`Lorem ipsum dolor sit amet consectetur. Pulvinar nunc egestas eleifend in vel erat. Massa velit sem aenean ultricies pellentesque est auctor duis placerat. Aliquet sed mi ullamcorper etiam non eu risus purus platea.`}
          OrangeBtn='Find more'
          />
        <AboutBlog/>
        <Lorem/>
        <Footer/>
    </div>
  )
}
